var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#404040"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33_316",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4792 27.5C13.1875 27.5695 12.934 27.4965 12.7188 27.2813C12.5035 27.066 12.4306 26.8125 12.5 26.5208L13.3333 22.5417L17.4583 26.6667L13.4792 27.5ZM17.4583 26.6667L13.3333 22.5417L22.875 13C23.1945 12.6806 23.5903 12.5208 24.0625 12.5208C24.5347 12.5208 24.9306 12.6806 25.25 13L27 14.75C27.3195 15.0695 27.4792 15.4653 27.4792 15.9375C27.4792 16.4097 27.3195 16.8056 27 17.125L17.4583 26.6667ZM24.0625 14.1667L15.4375 22.7917L17.2083 24.5625L25.8333 15.9375L24.0625 14.1667Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.595337b70193adeebeaef46be9e42c45.svg";
export { ForwardRef as ReactComponent };